const DIAGNOSES = [
  { value: 1, label: 'Hauptdiagnose' },
  { value: 2, label: '1. Nebendiagnose' },
  { value: 3, label: '2. Nebendiagnose' },
  { value: null, label: 'Keine Angabe' },
];

const BASE_DIAGNOSES_CODES = [
  {
    title: 'Klinisch-psychiatrisches Syndrom',
    items: [
      { value: 'F1', label: 'F1 Psychische und Verhaltensstörungen durch psychotrope Substanzen' },
      { value: 'F2', label: 'F2 Schizophrenie, schizotype und wahnhafte Störungen' },
      { value: 'F3', label: 'F3 Affektive Störungen' },
      { value: 'F4', label: 'F4 Neurotische, Belastungs- und somatoforme Störungen' },
      { value: 'F5', label: 'F5 Verhaltensauffälligkeiten mit körperlichen Störungen und Faktoren' },
      { value: 'F6', label: 'F6 Persönlichkeits- und Verhaltensstörungen' },
      { value: 'F84', label: 'F84 Tief greifende Entwicklungsstörungen' },
      { value: 'F90', label: 'F90 Hyperkinetische Störungen' },
      { value: 'F91', label: 'F91 Störungen des Sozialverhaltens' },
      { value: 'F92', label: 'F92 Kombinierte Störung des Sozialverhaltens und der Emotionen' },
      { value: 'F93', label: 'F93 Emotionale Störungen des Kindesalters' },
      { value: 'F94', label: 'F94 Störungen sozialer Funktionen mit Beginn in der Kindheit und Jugend' },
      { value: 'F95', label: 'F95 Ticstörungen' },
      { value: 'F98', label: 'F98 Andere Verhaltens- und emotionale Störungen mit Beginn in der Kindheit und Jugend' },
      { value: 'XKPS', label: 'Andere Diagnose (klinisch-psychiatrisches Syndrom)' },
    ],
  },
  {
    title: 'Umschriebene Entwicklungsstörungen',
    items: [
      { value: 'F80', label: 'F80 Umschriebene Entwicklungsstörungen des Sprechens und der Sprache' },
      { value: 'F81', label: 'F81 Umschriebene Entwicklungsstörungen schulischer Fertigkeiten' },
      { value: 'F82', label: 'F82 Umschriebene Entwicklungsstörung der motorischen Funktionen' },
      { value: 'F83', label: 'F83 Kombinierte umschriebene Entwicklungsstörungen' },
    ],
  },
  {
    title: 'Intelligenzstörung',
    items: [
      { value: 'F70', label: 'F70 Leichte Intelligenzminderung (IQ 50-69)' },
      { value: 'F71', label: 'F71 Mittelgradige Intelligenzminderung (IQ 35-49)' },
      { value: 'XIS', label: 'Andere Diagnose (Intelligenzstörung)' },
    ],
  },
  {
    title: 'Körperliche Symptomatik',
    items: [
      { value: 'KVII', label: 'Kapitel VII Krankheiten des Auges und der Augenanhangsgebilde' },
      { value: 'KVIII', label: 'Kapitel VIII Krankheiten des Ohres und des Mastoids' },
      { value: 'XKS', label: 'Andere Diagnose (Körperliche Symptomatik)' },
    ],
  },
];

const DIAGNOSES_CODES = [
  ...BASE_DIAGNOSES_CODES,
  {
    title: 'Unkategorisiert',
    items: [
      { value: 'KA', label: 'Keine' },
    ],
  },
];

const DIAGNOSES_CODES_WITH_DMS = [
  ...BASE_DIAGNOSES_CODES,
  {
    title: 'Unkategorisiert',
    items: [
      { value: 'DSM', label: 'DSM' },
      { value: 'KA', label: 'Keine' },
    ],
  },
];

export {
  DIAGNOSES,
  DIAGNOSES_CODES,
  DIAGNOSES_CODES_WITH_DMS,
};
